import React, { useEffect, useLayoutEffect} from 'react';
import {
    Button,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    Tooltip
} from "@chakra-ui/react";


export default function ContactPopover() {
    return (
<Popover placement='top-start'>
  <PopoverTrigger>
    <Button h='50px' w='125px' colorScheme='yellow'>Contact</Button>
  </PopoverTrigger>
  <PopoverContent zIndex={4}>
    <PopoverArrow />
    <PopoverCloseButton />
    <PopoverBody>
      <br/>Personal Contact<br/><br/><hr/><br/>
        e-mail  : <br/>
        xmandriansusanto@gmail.com <br/><br/>
        phone   : <br/>
        (+62) 0821 2000 1278 <br/><br/>
        LinkedIn    : <br/>
        linkedin.com/in/andriansusanto/
        <br/><br/>
    </PopoverBody>
  </PopoverContent>
</Popover>
    )
}